export const BASE_URL = 'https://api-exodus-enterprise.rango.exchange';
export const RANGO_BLOCKCHAIN_TO_NETWORK = new Map([
    ['ETH', 'ethereum'],
    ['POLYGON', 'matic'],
    ['AVAX_CCHAIN', 'avalanchec'],
    ['BNB', 'bnbmainnet'],
    ['BSC', 'bsc'],
    ['BASE', 'basemainnet'],
]);
export const NETWORK_TO_RANGO_BLOCKCHAIN = new Map([...RANGO_BLOCKCHAIN_TO_NETWORK.entries()].map(([key, val]) => [val, key]));
export const MIN_ETH_AMOUNT_USD = 10;
export const MIN_EVM_AMOUNT_USD = 2;
export const MAX_AMOUNT_USD = 100_000;
export const DEFAULT_SLIPPAGE = 2;
export const DEFAULT_FEE_BPS = 100;
export const DEFAULT_FEE_ADDRESS = '0xe4f7e5e9f3c3f3f3e3e3e3e3e3e3e3e3e3e3e3e3';
export const SVC = 'rango';
export const GAS_LIMIT_MULTIPLIER = 1.5;
export const DEFAULT_SPENDER_ADDRESS = '0x69460570c93f9DE5E2edbC3052bf10125f0Ca22d';
